/**
 * Página de Paquetes de Jornadas (Área Privada)
 *
 * Esta página permite a los tutores:
 * - Ver paquetes de jornadas disponibles para compra
 * - Filtrar por torneo y sede
 * - Ver información de disponibilidad de inscripción
 * - Iniciar proceso de compra de paquetes
 */

import InscripcionJornadas from '../components/InscripcionJornadas';

const Products = () => {
  return <InscripcionJornadas />;
};

export default Products;